import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { inventoryItemByInventoryByStatusMini } from "../../../../graphql/inventory/custom-queries";

import { Grid } from "@material-ui/core";

import {
  ArrayField,
  Datagrid,
  FunctionField,
  NumberField,
  ResourceContextProvider,
  TextField,
  useNotify,
} from "react-admin";

import { isAuthorized, logError } from "../../../../utils/appUtils";
import { AclType, InventoryStatus } from "../../../../utils/constants";
import { exceptionRenderer } from "../../../../utils/utils";
import { OpenInventoryItemButton } from "./OpenInventoryItemButton";
import { sortByLocation } from "../../../../utils/locationUtils";

export const LocationsPeak = (props) => {
  const notify = useNotify();
  const [locations, setLocations] = useState([]);
  const { record, basePath } = props;

  useEffect(() => {
    if (record.id) getLocationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLocationData = async () => {
    try {
      debugger;
      const response = await API.graphql(
        graphqlOperation(inventoryItemByInventoryByStatusMini, {
          inventoryId: record.id,
          status: { beginsWith: InventoryStatus.STORED },
          limit: 500,
        })
      );
      const inventoryItems =
        response.data.inventoryItemByInventoryByStatus.items;

      if (inventoryItems) {
        const sortedItems = {
          items: sortByLocation(inventoryItems),
        };
        setLocations(sortedItems);
      }
    } catch (error) {
      logError("inventoryItems:LocationsPeak:getLocationData", error, notify);
    }
  };

  if (locations?.items?.length === 0) return <></>;
  return (
    <ResourceContextProvider value="inventoryItems">
      <Grid container>
        <Grid item xs={false} sm={1}>
          <></>
        </Grid>
        <Grid item xs={12} sm={10}>
          <ArrayField source="items" record={locations} fullWidth>
            <Datagrid>
              <FunctionField
                source="hasException"
                label=" "
                render={exceptionRenderer}
              />
              <TextField
                source="locationFullName"
                label="Location"
                record={locations}
                sortable={false}
              />
              <NumberField
                source="quantityOnHand"
                label="Qty. On Hand"
                sortable={false}
              />
              <NumberField
                source="quantityCommitted"
                label="Qty. Committed"
                sortable={false}
              />
              {isAuthorized(AclType.ASSIGN_LOCATION) && (
                <OpenInventoryItemButton
                  inventory={record}
                  backPath={[basePath]}
                />
              )}
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={false} sm={3}>
          <></>
        </Grid>
      </Grid>
    </ResourceContextProvider>
  );
};
